(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:ContextMenuService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('ContextMenuService', ContextMenuService);

    function ContextMenuService(EventManagerService, CommonMasterData) {
        var self = this,
            isRightClickPrivilegeLoad = false,
            rightClickPrivilegeList = {},
            rightClickPrivileges = {},
            leaveAssignmentRightClickOptions = [],
            eventAssignmentRightClickOptions = [],
            baseListSubMenu =[],
            menuTypes = {
                DUTY: 'Context Menu for right click on Duty',
                DUTY_IN_PAIRING: 'Context Menu for right click on Duty with in a Pairing',
                PAIRING: 'Context Menu for right click on a Pairing',
                DATE: 'Context Menu for right click on Date',
                CREW: 'Context Menu for right click on Crew',
                DELETE: 'Context Menu for right click on Ctrl+Click selected Blocks',
                SWAP: 'Context Menu for Swaping',
                UPDATE_FLIGHT: 'Update flight',
                DELETE_FLIGHT: 'Delete flight',
                CREW_WATCH_SEND_CREW_NOTIFICATION: 'crew watch send crew notification',
                DELAY_CODE:'delay codes of flight puntuality',
                EDIT:'edit flight of flight puntuality',
                SMS:'context menu for send sms',
                SEND_NOTIFICATION:'context menu for send notification',
                CUT: 'context menu for post cut operation',
                COPY: 'context menu for post copy operation',
                LEAVE: 'context menu for leave block',
                EDIT_CHECK: 'context enu for edit check',
                SCHEDULE_DUTY: 'Context Menu for crew schedule right click on Duty',
                SCHEDULE_DUTY_IN_PAIRING: 'Context Menu for crew schedule right click on Duty with in a Pairing',
                SCHEDULE_EVENT_IN_PAIRING: 'Context Menu for crew schedule right click on Event with in a Pairing',
                SCHEDULE_EVENT : 'Context Menu for crew schedule right click on Events only',
                SCHEDULE_SBY_EVENT : 'Context Menu for crew schedule right click on StandBy Events only',
                SCHEDULE_LEAVE: 'context menu for crew schedule right click on leave block',
                CANCEL_COPY_OPERATIONS: 'Context menu for cancel Copy actions',
                CANCEL_CUT_OPERATIONS: 'Context menu for cancel Cut actions',
                TOP_HEADER_DATES : 'context menu for top header date',
                TRAINING: 'context menu for training delete',
                MULTIPLE_TRAINING_SELECTION: 'context menu for multiple trainings',
                VISIBILITY_SHOW : 'context menu for visibility show changes',
                VISIBILITY_HIDE : 'context menu for visibility hide changes',
                SHOW_VIOLATION: 'show violation reasons in menu',
                MANAGE_PAIRING: 'Context Menu for manage pairing',
                DELETE_CHECK: 'Delete Check',
                BIDDING_CREW: 'Context menu for right click on Bidding Crew Name',
                ACKNOWLEDGE_DUTY: 'Context menu for acknowledge the duty',
                CONVERT_TO_SICK: 'Context menu for converting SWO event to Sick Leave back',
                DELAYED_REPORT_TIMING: 'Context menu for delayed report timing'
            },
            contextMenuCol = [
                {
                    id: 1,
                    name: 'Copy',
                    icon: 'content_copy',
                    event: EventManagerService.EVENT.CONTEXT_MENU.COPY_DUTY,
                    includeIn: ['DUTY', 'LEAVE', 'DUTY_IN_PAIRING', 'PAIRING']
                },
                {
                    id: 2,
                    name: 'Cut',
                    icon: 'content_cut',
                    event: EventManagerService.EVENT.CONTEXT_MENU.CUT_BLOCK,
                    includeIn: ['DUTY', 'LEAVE', 'DUTY_IN_PAIRING', 'PAIRING']
                },
                {
                    id: 3,
                    name: 'Delete',
                    icon: 'delete',
                    event: EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK,
                    includeIn: ['DUTY', 'LEAVE','SCHEDULE_LEAVE', 'DELETE', 'DUTY_IN_PAIRING', 'SWAP', 'PAIRING', 'SCHEDULE_DUTY_IN_PAIRING', 'SCHEDULE_EVENT_IN_PAIRING', 'SCHEDULE_DUTY', 'TRAINING','MULTIPLE_TRAINING_SELECTION','MANAGE_PAIRING','SCHEDULE_EVENT']
                },
                {
                    id: 4,
                    name: 'Edit Pairing',
                    icon: 'create',
                    event: EventManagerService.EVENT.CONTEXT_MENU.EDIT_PAIRING,
                    includeIn: ['DUTY_IN_PAIRING', 'PAIRING', 'SCHEDULE_DUTY_IN_PAIRING']
                },
                {
                    id: 5,
                    name: 'Edit Block',
                    icon: 'border_color',
                    event: EventManagerService.EVENT.CONTEXT_MENU.EDIT_BLOCK,
                    includeIn: ['DUTY_IN_PAIRING', 'SCHEDULE_DUTY_IN_PAIRING', 'SCHEDULE_DUTY', 'SCHEDULE_EVENT_IN_PAIRING']
                },
                {
                  id: 78,
                  name: 'Replace Pairing',
                  icon: 'border_color',
                  event: EventManagerService.EVENT.CONTEXT_MENU.REPLACE_PARING,
                  includeIn: ['DUTY_IN_PAIRING', 'SCHEDULE_DUTY_IN_PAIRING', 'SCHEDULE_DUTY', 'SCHEDULE_EVENT_IN_PAIRING']
                },
                {
                  id: 52,
                  name: 'Edit Event',
                  icon: 'border_color',
                  event: EventManagerService.EVENT.CONTEXT_MENU.EDIT_EVENT,
                  includeIn: ['SCHEDULE_EVENT','DUTY']
                },
                {
                    id: 6,
                    name: 'Regulation Details',
                    icon: 'gavel',
                    event: EventManagerService.EVENT.CONTEXT_MENU.REGULATION_DETAILS,
                    includeIn: ['DUTY', 'DUTY_IN_PAIRING', 'SCHEDULE_DUTY_IN_PAIRING', 'SCHEDULE_DUTY', 'SCHEDULE_EVENT_IN_PAIRING','SCHEDULE_EVENT']
                },
                {
                    id: 7,
                    name: 'Show All Crew Schedule',
                    icon: 'people',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SHOW_ALL_CREW_SCHEDULE,
                    includeIn: ['DUTY', 'LEAVE', 'DUTY_IN_PAIRING', 'SCHEDULE_DUTY']
                },
                {
                    id: 8,
                    name: 'Deselect',
                    icon: 'clear',
                    event: EventManagerService.EVENT.CONTEXT_MENU.DESELECT_ALL,
                    includeIn: ['DELETE', 'SWAP', 'MULTIPLE_DAY_SELECTION', 'MULTIPLE_CREW_SELECTION','TRAINING', 'MULTIPLE_TRAINING_SELECTION','MANAGE_PAIRING'],
                    order: {
                        MULTIPLE_DAY_SELECTION: 2
                    }
                },
                {
                    id: 9,
                    name: 'Assign Pairing',
                    icon: 'create',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PAIRING,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 1
                    }
                },
                {
                    id: 10,
                    name: 'Assign Event',
                    icon: 'event',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 2
                    }
                },
                {
                    id: 11,
                    name: 'Assign Training',
                    icon: 'rowing',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_TRAINING,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 3
                    }
                },
                {
                    id: 12,
                    name: 'Add Memo',
                    icon: 'class',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ADD_MEMO,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 8
                    }
                },
                {
                    id: 13,
                    name: 'Alert',
                    icon: 'add_alert',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ALERT,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 9
                    }
                },
                {
                    id: 14,
                    name: 'SMS',
                    icon: 'textsms',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SMS,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 10
                    }
                },
                {
                    id: 15,
                    name: 'History',
                    icon: 'history',
                    event: EventManagerService.EVENT.CONTEXT_MENU.HISTORY,
                    includeIn: ['DATE'],
                    order: {
                        DATE: 11
                    }
                }
                ,
                {
                    id: 16,
                    name: 'Email',
                    icon: 'email',
                    event: EventManagerService.EVENT.CONTEXT_MENU.EMAIL_CREW,
                    includeIn: ['CREW']
                },
                {
                    id: 18,
                    name: 'Crew Schedule',
                    icon: 'create',
                    event: EventManagerService.EVENT.CONTEXT_MENU.CREW_SCHEDULE,
                    includeIn: ['CREW', 'BIDDING_CREW', 'BIDDING_CREW_ONLY']
                },
                {
                    id: 19,
                    name: 'Swap',
                    icon: 'swap_vert',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SWAP,
                    includeIn: ['SWAP']
                },
                {
                    id: 20,
                    name: 'Update Flight',
                    icon: 'border_color',
                    event: EventManagerService.EVENT.CONTEXT_MENU.UPDATE_FLIGHT,
                    includeIn: ['UPDATE_FLIGHT'],
                    privilege: 'RIGHT_CLICK_UPDATE_FLIGHT'
                },
                {
                    id: 21,
                    name: 'Paste',
                    icon: 'content_paste',
                    event: EventManagerService.EVENT.CONTEXT_MENU.PAST_BLOCK,
                    includeIn: ['CUT', 'COPY']
                },
                {
                    id: 22,
                    name: 'Cancel Cut Operation',
                    icon: 'cancel',
                    event: EventManagerService.EVENT.CONTEXT_MENU.CANCEL_CUT_OPERATION,
                    includeIn: ['CUT', 'CANCEL_CUT_OPERATIONS']
                },
                {
                    id: 22,
                    name: 'Cancel copy Operation',
                    icon: 'cancel',
                    event: EventManagerService.EVENT.CONTEXT_MENU.CANCEL_COPY_OPERATION,
                    includeIn: ['COPY', 'CANCEL_COPY_OPERATIONS']
                },
                {
                    id: 23,
                    name: 'Add Day Off to ..',
                    icon: 'add',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ADD_OFF_TO,
                    includeIn: ['DAY_OFF_ONLY', 'DAY_OFF', 'PAIRING_CONVERT']
                },
                {
                    id: 24,
                    name: 'Add Day Off to next day',
                    icon: 'fast_forward',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ADD_OFF_TO_NEXT_DAY,
                    includeIn: ['DAY_OFF', 'PAIRING_CONVERT']
                },
                {
                    id: 25,
                    name: 'Add Day Off to previous day',
                    icon: 'fast_rewind',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ADD_OFF_TO_PREVIOUS_DAY,
                    includeIn: ['DAY_OFF', 'PAIRING_CONVERT']
                },
                {
                    id: 26,
                    name: 'Convert to Flight Dead Heading',
                    icon: 'compare_arrows',
                    event: EventManagerService.EVENT.CONTEXT_MENU.CONVERT_TO_DEADHEAD,
                    includeIn: ['PAIRING_CONVERT', 'PAIRING_CONVERT_NO_OFF_RELEVANT']
                },
                {
                    id: 27,
                    name: 'Expiry',
                    icon: 'hourglass_empty',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SHOW_CREW_EXPIRY,
                    includeIn: ['CREW']
                },
                {
                    id: 28,
                    name: 'Assign Leave',
                    icon: 'beach_access',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_LEAVE,
                    includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                    order: {
                        DATE: 4
                    },
                    subMenu : [
                      {
                        id: 73,
                        name: 'Absent',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ABSENT_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 1
                        },
                        code: 'ABS'
                      },
                      {
                        id: 30,
                        name: 'Annual Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ANNUAL_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 2
                        },
                        code: 'ALV'
                      },
                      {
                        id: 78,
                        name: 'Block days ( Similar to COM )',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_BLOCK_DAYS,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 3
                        },
                        code: 'BLK'
                      },
                      {
                        id: 74,
                        name: 'Commuting leaves',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_COMMUTING_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 4
                        },
                        code: 'CLV'
                      },
                      {
                        id: 65,
                        name: 'Compassionate Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_COMPASSIONATE_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 5
                        },
                        code: 'COM'
                      },
                      {
                        id: 62,
                        name: 'Emergency Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EMERGENCY_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 6
                        },
                        code: 'ELV'
                      },
                      {
                        id: 76,
                        name: 'Force Majeure',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_FM_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 7
                        },
                        code: 'FM'
                      },
                      {
                        id: 77,
                        name: 'Flexible Sick Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_FLEXIBLE_SICK_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 8
                        },
                        code: 'FSLV'
                      },
                      {
                        id: 64,
                        name: 'Hajj Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_HAJJ_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 9
                        },
                        code: 'HAJ'
                      },
                      {
                        id: 63,
                        name: 'Industrial Accident Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_IND_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 10
                        },
                        code: 'IND'
                      },
                      {
                        id: 70,
                        name: 'Marriage Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_MARRIAGE_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 11
                        },
                        code: 'MAR'
                      },
                      {
                        id: 66,
                        name: 'Maternity Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_MATERNITY_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 12
                        },
                        code: 'MAT'
                      },
                      {
                        id: 72,
                        name: 'No Show',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_NOSHOW_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 13
                        },
                        code: 'NSH'
                      },
                      {
                        id: 60,
                        name: 'Off',
                        icon: 'beach_access',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_OFF,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 14
                        },
                        code: 'OFF'
                      },
                      {
                        id: 67,
                        name: 'Paternity Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PATERNITY_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 15
                        },
                        code: 'PAT'
                      },
                      {
                        id: 29,
                        name: 'Sick Leave',
                        icon: 'mood_bad',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SICK_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 16
                        },
                        code: 'SLV'
                      },
                      {
                        id: 79,
                        name: 'Super Neumerary',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SNY_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 17
                        },
                        code: 'SNY'
                      },
                      {
                        id: 75,
                        name: 'Special Unpaid Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SPECIAL_UNPAID_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 18
                        },
                        code: 'SULV'
                      },
                      {
                        id: 71,
                        name: 'Suspension',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SUSPENSION_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 19
                        },
                        code: 'SUS'
                      },
                      {
                        id: 61,
                        name: 'Unpaid Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_UNPAID_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 20
                        },
                        code: 'ULV'
                      },
                      {
                        id: 69,
                        name: 'Unpaid Sick Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_UNPAID_SICK_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 21
                        },
                        code: 'USL'
                      },
                      {
                        id: 59,
                        name: 'Voluntarily Unpaid Leave',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_VOLUNTARILY_UNPAID_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 22
                        },
                        code: 'VULV'
                      },
                      {
                        id: 60,
                        name: 'Waiting for Documents',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_WFD_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 23
                        },
                        code: 'WFD'
                      },
                      {
                        id: 61,
                        name: 'Away from Base',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_AWB_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 24
                        },
                        code: 'AWB'
                      },
                      {
                        id: 62,
                        name: 'Limited Hours',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_LIM_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 25
                        },
                        code: 'LIM'
                      },
                      {
                        id: 63,
                        name: 'Voluntiary Unpaid Absence',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_VUNP_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 26
                        },
                        code: 'VUNP'
                      },
                      {
                        id: 64,
                        name: 'Sick Between Duties',
                        icon: 'hot_tub',
                        event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SBD_LEAVE,
                        includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                        order: {
                          SUB: 27
                        },
                        code: 'SBD'
                      }
                    ]
                },
                {
                    id: 31,
                    name: 'Assign Block Days',
                    icon: 'do_not_disturb_alt',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_BLOCK_DAYS,
                    includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                    order: {
                        DATE: 7
                    }
                },
                {
                    id: 32,
                    name: 'Edit Check ',
                    icon: 'border_color',
                    event: EventManagerService.EVENT.CONTEXT_MENU.EDIT_CHECK,
                    includeIn: ['EDIT_CHECK']
                },
                {
                    id: 33,
                    name: 'Move to Top',
                    icon: 'arrow_upward',
                    event: EventManagerService.EVENT.CONTEXT_MENU.CREW_MOVE_TO_TOP,
                    includeIn: ['CREW', 'MULTIPLE_CREW_SELECTION']
                },
                {
                    id: 34,
                    name: 'Filter',
                    icon: 'filter_list',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SHOW_CREW_FILTER,
                    includeIn: ['TOP_HEADER_DATES']
                },
                {
                    id: 35,
                    name: 'Assign Crew',
                    icon: 'assignment',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CREW_TO_TRAINING,
                    includeIn: ['TRAINING']
                },
                {
                    id: 36,
                    name: 'Open Crew Tracking',
                    icon: 'track_changes',
                    event: EventManagerService.EVENT.CONTEXT_MENU.OPEN_CREW_TRACKING,
                    includeIn: ['TOP_HEADER_DATES']
                },
                {
                    id: 37,
                    name: 'Show in Crew Potal',
                    icon: 'visibility',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SHOW_IN_CREW_PORTAL,
                    includeIn: ['VISIBILITY_SHOW']
                },
                {
                    id: 38,
                    name: 'Hide in Crew Portal',
                    icon: 'visibility_off',
                    event: EventManagerService.EVENT.CONTEXT_MENU.HIDE_IN_CREW_PORTAL,
                    includeIn: ['VISIBILITY_HIDE']
                },
                {
                    id: 39,
                    name: 'Violation Reason',
                    icon: 'assignment',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SHOW_VIOLATIONS,
                    includeIn: ['SHOW_VIOLATION']
                },
                {
                    id: 40,
                    name: 'APP/APIS',
                    icon: 'email',
                    event: EventManagerService.EVENT.CONTEXT_MENU.PAX_MSG_DETAILS,
                    includeIn: ['DUTY', 'DUTY_IN_PAIRING', 'SCHEDULE_DUTY_IN_PAIRING', 'SCHEDULE_EVENT_IN_PAIRING', 'SCHEDULE_DUTY','SCHEDULE_EVENT']
                },
                {
                    id: 41,
                    name: 'Select All',
                    icon: 'assignment',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SELECT_ALL,
                    includeIn: ['MANAGE_PAIRING']
                },
                {
                    id: 42,
                    name: 'Send Notifications',
                    icon: 'send',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SEND_CREW_NOTIFICATION,
                    includeIn: ['UPDATE_FLIGHT'],
                    privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
                },
                {
                    id: 43,
                    name: 'Send Notifications',
                    icon: 'send',
                    event: EventManagerService.EVENT.CONTEXT_MENU.SEND_CREW_NOTIFICATION,
                    includeIn: ['CREW_WATCH_SEND_CREW_NOTIFICATION'],
                    privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
                },
                {
                  id: 44,
                  name: 'Delay Codes',
                  event: EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.DELAY_CODES,
                  includeIn: ['DELAY_CODE'],
                  privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
                },
                {
                  id: 45,
                  name: 'Edit',
                  event: EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.EDIT,
                  includeIn: ['DELAY_CODE'],
                  privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
                },
                {
                  id: 46,
                  name: 'SMS',
                  event: EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.SMS,
                  includeIn: ['DELAY_CODE'],
                  privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
                },
              {
                id: 47,
                name: 'Crew Details',
                event: EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.CREW_DETAILS,
                includeIn: ['DELAY_CODE'],
                privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
              },
              {
                id: 48,
                name: 'Lido',
                event: EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.LIDO,
                includeIn: ['DELAY_CODE'],
                privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
              },
              {
                id: 49,
                name: 'Flight Log',
                event: EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.FLIGHT_LOG,
                includeIn: ['DELAY_CODE'],
                privilege: 'RIGHT_CLICK_SEND_NOTIFICATIONS'
              },
              {
                  id: 50,
                  name: 'Unassign Flight',
                  icon: 'cancel',
                  event: EventManagerService.EVENT.CONTEXT_MENU.DELETE_FLIGHT,
                  includeIn: ['UPDATE_FLIGHT'],
                  privilege: 'RIGHT_CLICK_UPDATE_FLIGHT'
              },
              {
                  id: 51,
                  name: 'Delete Check',
                  icon: 'cancel',
                  event: EventManagerService.EVENT.CONTEXT_MENU.DELETE_CHECK,
                  includeIn: ['EDIT_CHECK'],
                  privilege: 'RIGHT_CLICK_UPDATE_FLIGHT'
              },
              {
                id: 53,
                name: 'Show Log',
                icon: 'assignment',
                event: EventManagerService.EVENT.CONTEXT_MENU.SHOW_LOG,
                includeIn: ['EDIT_CHECK']
              },

              {
                id: 54,
                name: 'Approve All',
                icon: 'add',
                event: EventManagerService.EVENT.CONTEXT_MENU.BIDDING_APPROVE_ALL,
                includeIn: ['BIDDING_CREW','BIDDING_ONLY']
              },

              {
                id: 55,
                name: 'Approve Events',
                icon: 'event',
                event: EventManagerService.EVENT.CONTEXT_MENU.BIDDING_APPROVE_EVENT,
                includeIn: ['BIDDING_CREW','BIDDING_ONLY']
              },
              {
                id: 56,
                name: 'Approve Patterns',
                icon: 'assignment',
                event: EventManagerService.EVENT.CONTEXT_MENU.BIDDING_APPROVE_PATTERN,
                includeIn: ['BIDDING_CREW','BIDDING_ONLY']
              },
              {
                id: 57,
                name: 'Delete All',
                icon: 'cancel',
                event: EventManagerService.EVENT.CONTEXT_MENU.BIDDING_DELETE_ALL,
                includeIn: ['BIDDING_CREW','BIDDING_ONLY']
              },
              {
                  id: 58,
                  name: 'Assign CNT',
                  icon: 'beach_access',
                  event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CNT,
                  includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                  order: {
                      DATE: 4
                  }

              },
              {
                id: 60,
                name: 'Call Out For Duty',
                icon: 'create',
                event: EventManagerService.EVENT.CONTEXT_MENU.SBY_CALL_OUT,
                includeIn: ['SCHEDULE_SBY_EVENT'],
                order: {
                  DATE: 1
                }
              },
              {
                id: 61,
                name: 'Convert to Flight Dead Head Positioning',
                icon: 'compare_arrows',
                event: EventManagerService.EVENT.CONTEXT_MENU.CONVERT_TO_DEADHEAD_POSITIONING,
                includeIn: ['PAIRING_CONVERT', 'PAIRING_CONVERT_NO_OFF_RELEVANT']
              },
              {
                id: 62,
                name: 'Update Results',
                icon: 'create',
                event: EventManagerService.EVENT.CONTEXT_MENU.EVALUATE_TRAININGS,
                includeIn: [ 'UPDATE_RESULTS' ]
              },{
                id: 63,
                name: 'Accept Duty',
                icon: 'assignment',
                event: EventManagerService.EVENT.CONTEXT_MENU.ACCEPT_DUTY,
                includeIn: ['DUTY'],
                privilege: 'DUTY_CHANGE'
              },
              {
                id: 68,
                name: 'Assign Event',
                icon: 'event',
                event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT,
                includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                order: {
                  DATE: 4
                },
                subMenu : [
                  {
                    id: 80,
                    name: 'Office duties',
                    icon: 'event',
                    event: '',
                    includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                    order: {
                      SUB: 1
                    },
                    subMenu:[{
                      id: 82,
                      name: 'Hubs',
                      icon: '',
                      event: '',
                      includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                      order: {
                        SUB: 1
                      },
                      code: 'Hubs'
                    }],
                    code: 'OFC'
                  },
                  {
                    id: 81,
                    name: 'Cabin special duty',
                    icon: 'work',
                    event: '',
                    includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                    order: {
                      SUB: 2
                    },
                    subMenu:[{
                      id: 82,
                      name: 'Hubs',
                      icon: '',
                      event: '',
                      includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                      order: {
                        SUB: 2
                      },
                      code: 'Hubs'
                    }],
                    code: 'CSD'
                  },
                  {
                    id: 82,
                    name: 'Cabin support activity',
                    icon: 'work',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CABIN_SUPPORT_ACTIVITY,
                    includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                    order: {
                      SUB: 3
                    },
                    code: 'CSA'
                  },
                  {
                    id: 83,
                    name: 'Seconded in other hub',
                    icon: 'work',
                    event: '',
                    includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                    order: {
                      SUB: 4
                    },
                    subMenu:[{
                      id: 85,
                      name: 'Hubs',
                      icon: '',
                      event: '',
                      includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                      order: {
                        SUB: 4
                      },
                      code: 'Hubs'
                    }],
                    code: 'SOH'
                  },
                  {
                    id: 84,
                    name: 'Available',
                    icon: 'work',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_AVAILABLE,
                    includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                    order: {
                      SUB: 4
                    },
                    code: 'AVL'
                  },
                  {
                    id: 85,
                    name: 'To Be Notified',
                    icon: 'work',
                    event: EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_TO_BE_NOTIFIED,
                    includeIn: [ 'MULTIPLE_DAY_SELECTION'],
                    order: {
                      SUB: 4
                    },
                    code: 'TBN'
                  }
                ]},
              {
                id: 64,
                name: 'Acknowledge Duty',
                icon: 'done',
                event: EventManagerService.EVENT.CONTEXT_MENU.ACKNOWLEDGE_DUTY,
                includeIn: ['ACKNOWLEDGE_DUTY'],
                order: {
                  DATE: 1
                }
              },
              {
                id: 81,
                name: 'Convert to Sick Leave',
                icon: 'done',
                event: EventManagerService.EVENT.CONTEXT_MENU.CONVERT_TO_SICK,
                includeIn: ['SWO'],
                privilege: ['RIGHT_CLICK_CONVERT_SICK'],
                order: {
                  DATE: 1
                }
              },
              {
                id: 82,
                name: 'Copy All',
                icon: 'content_copy',
                event: EventManagerService.EVENT.CONTEXT_MENU.COPY_MULTIPLE_DUTY,
                includeIn: ['COPY_MULTIPLE']
              },
              {
                id: 83,
                name: 'Duty Time Regulator',
                icon: 'create',
                event: EventManagerService.EVENT.CONTEXT_MENU.DELAYED_REPORT_TIMING,
                includeIn: ['DUTY_IN_PAIRING', 'PAIRING', 'SCHEDULE_DUTY_IN_PAIRING']
              },
              {
                id: 84,
                name: 'Ignore Violations',
                icon: 'remove_circle_outline',
                event: EventManagerService.EVENT.CONTEXT_MENU.IGNORE_REGULATION_VIOLATION,
                privilege: 'RIGHT_CLICK_IGNORE_REGULATION_VIOLATIONS',
                includeIn: ['IGNORE_VIOLATION']
              },
              {
                id: 6,
                name: 'Restore Violations',
                icon: 'settings_backup_restore',
                event: EventManagerService.EVENT.CONTEXT_MENU.REVERT_IGNORED_REGULATION_VIOLATION,
                privilege: 'RIGHT_CLICK_RESTORE_REGULATION_VIOLATIONS',
                includeIn: ['RESTORE_IGNORED_VIOLATION']
              },
              {
                id: 85,
                name: 'Send Notification',
                icon: 'textsms',
                event: EventManagerService.EVENT.CONTEXT_MENU.SEND_NOTIFICATION,
                includeIn: ['DUTY', 'DUTY_IN_PAIRING', 'SCHEDULE_DUTY_IN_PAIRING', 'SCHEDULE_EVENT_IN_PAIRING','SCHEDULE_EVENT'],
                order: {
                  DATE: 10
                }
              },
            ];
        // load right click privileges
        loadRightClickPrivileges();

        loadUserPreferencesForRightClickLeaveAssignment();

        loadUserPreferencesForRightClickEventAssignment();

      loadBaseList();

        function loadRightClickPrivileges() {
          if(!isRightClickPrivilegeLoad){
            CommonMasterData.getRightClickContextMenuPrivileges(function(privilegeList) {
              rightClickPrivilegeList = privilegeList;
              rightClickPrivileges = rightClickPrivilegeList["RIGHT_CLICK"];
              isRightClickPrivilegeLoad = true;
            }, function() {
              console.log('Report Privilege List retrieval error!!!');
            });
          }
        }

        function loadUserPreferencesForRightClickLeaveAssignment() {
          CommonMasterData.getRightClickLeaveAssignmentOptions(function(preferencesList) {
            leaveAssignmentRightClickOptions = preferencesList;
          }, function () {
            console.log('Right Click User Leave Preferences Retrieval Eroor!!!');
          });
        }

      function loadUserPreferencesForRightClickEventAssignment() {
        CommonMasterData.getRightClickEventAssignmentOptions(function(preferencesList) {
          eventAssignmentRightClickOptions = preferencesList;
        }, function () {
          console.log('Right Click User Event Preferences Retrieval Eroor!!!');
        });
      }
      function loadBaseList() {
        CommonMasterData.getCrewBaseList(function(baseList) {
          baseListSubMenu = prepareBasListSubmenu(baseList);
        }, function () {
          console.log('baseList Retrieval Eroor!!!');
        });
      }

      function prepareBasListSubmenu(baseList){

          var subMenuList = baseList.map(function(airport, index) {
            return {
              id: 81 + index, // Assuming id needs to be unique, incrementing for each airport
              name: airport.airPortCode,
              icon: 'location_on',
              event: '',
              includeIn: ['MULTIPLE_DAY_SELECTION'],
              order: {
                SUB: index
              },
              code: airport.airPortCode
            };
          });
          return subMenuList
      }

      function getEventAccordingToEvenCode(eventCode){
          if(eventCode  == null){
            return null;
          }else if(eventCode  == 'OFC'){
            return EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT_OFC;
          }else if(eventCode  == 'CSD'){
            return EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CABIN_SPECIAL_DUTY;
          }else if(eventCode  == 'SOH'){
            return EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SECONDEDIN_OTHER_HUBS;
          }
      }

      function getEventFromCode(code){
          return  'event.context_menu.assign_' + code;
      };

      function getMenuHtml(menuType) {
          var generatedMenu = [];
          var customHtml;
          var customItem;

          angular.forEach(contextMenuCol, function (menu) {
            // check privilege
            if(!menu.privilege || (!!rightClickPrivileges && rightClickPrivileges[menu.privilege])){
              if (menu.includeIn.indexOf(menuType) >= 0) {
                if (menu.id == 44 || menu.id == 45 || menu.id == 46 || menu.id == 47 || menu.id == 48 || menu.id == 49) {
                  customHtml = '<a href="">' + menu.name + '</a>';
                }
                else {
                  customHtml = '<a href=""><i class="material-icons">' + menu.icon + '</i>' + menu.name + '</a>';
                }
                if (menu.id !== 28 && menu.id !== 68) {
                  customItem = {
                    html: customHtml, click: function ($itemScope, $event, modelValue) {
                      console.log($itemScope);
                      console.log("===================");
                      console.log(modelValue);
                      var params = {
                        event: $event,
                        items: $itemScope,
                        modelValue: modelValue
                      };
                      EventManagerService.notifyEventListeners(menu.event, params);
                    }
                  };
                  customItem.order = (menu.order && menu.order[menuType]) || 1;
                  generatedMenu.push(customItem);
                }
                else {
                  var childItems = [];
                  var childItem = {};
                  if (menu.id == 28){
                    var leaveTypeMap = {};
                    const leaveIconMap = {
                        DEFAULT: 'hot_tub',
                        SLV: 'mood_bad',
                        OFF: 'beach_access'
                    };

                    angular.forEach(leaveAssignmentRightClickOptions, function (option, index) {

                        const icon = leaveIconMap[option.eventCode] || leaveIconMap.DEFAULT;

                        leaveTypeMap[option.eventCode] = {
                            id: index,
                            name: option.description,
                            icon: icon,
                            event: getEventFromCode(option.eventCode),
                            includeIn: ['DATE', 'MULTIPLE_DAY_SELECTION'],
                            order: {
                                SUB: index + 1
                            },
                            code: option.eventCode
                        };

                    });

                    angular.forEach(leaveAssignmentRightClickOptions, function (option) {

                        var config = leaveTypeMap[option.eventCode];

                        var childItem = {
                            html: '<a href=""><i class="material-icons">' + config.icon + '</i>' + option.description + '</a>',
                            click: function ($itemScope, $event, modelValue) {
                                var params = {
                                    event: $event,
                                    items: $itemScope,
                                    modelValue: modelValue
                                };
                                EventManagerService.notifyEventListeners(config.event, params);
                            }
                        };

                        childItem.order = (config.order && config.order['SUB']) || 1;

                        childItems.push(childItem);
                    });
                  }else if(menu.id == 68){
                    const eventIconMap = {
                      DEFAULT: 'work',
                      OFC: 'event',
                      CSD: 'work',
                      CSA: 'work',
                      SOH: 'work',
                      AVL: 'work',
                      TBN: 'work'
                    };

                    var eventTypeMap = {};

                    angular.forEach(eventAssignmentRightClickOptions, function (option, index) {

                        const icon = eventIconMap[option.eventCode] || eventIconMap.DEFAULT;

                        eventTypeMap[option.eventCode] = {
                            id: index,
                            name: option.description,
                            icon: icon,
                            event: getEventFromCode(option.eventCode),
                            includeIn: ['MULTIPLE_DAY_SELECTION'],
                            order: {
                                SUB: index + 1
                            },
                            code: option.eventCode
                        };

                    });

                    angular.forEach(eventAssignmentRightClickOptions, function (option) {

                        var config = eventTypeMap[option.eventCode];

                        var childItem = {
                            html: '<a href=""><i class="material-icons">' + config.icon + '</i>' + option.description + '</a>',
                            click: function ($itemScope, $event, modelValue) {
                                var params = {
                                    event: $event,
                                    items: $itemScope,
                                    modelValue: modelValue
                                };
                                EventManagerService.notifyEventListeners(config.event, params);
                            }
                        };

                        childItem.order = (config.order && config.order['SUB']) || 1;

                        if(config.code == 'OFC' || config.code == 'CSD' || config.code == 'SOH'){
                          var thirdLevelItems = [];
                          console.log(baseListSubMenu)
                          prepareBasListSubmenu(baseListSubMenu)
                          angular.forEach(baseListSubMenu, function (thirdLevelSub) {
                            var thirdLevelItem = {
                              html: '<a href=""><i class="material-icons">' + thirdLevelSub.icon + '</i>' + thirdLevelSub.name + '</a>',
                              click: function ($itemScope, $event, modelValue) {
                                var params = {
                                  event: $event,
                                  items: $itemScope,
                                  modelValue: modelValue,
                                  selectedBase: thirdLevelSub.name
                                };
                                EventManagerService.notifyEventListeners(getEventAccordingToEvenCode(config.code), params);
                              }
                            };
                            thirdLevelItem.order = (thirdLevelSub.order && thirdLevelSub.order['SUB']) || 1;
                            thirdLevelItems.push(thirdLevelItem);
                          });

                          childItem.children = thirdLevelItems;
                        }
                        childItems.push(childItem);
                    });
                  }


//                  angular.forEach(menu.subMenu, function (subs) {
//                    if (leaveAssignmentRightClickOptions.includes(subs.code) || eventAssignmentRightClickOptions.includes(subs.code)) {
//                      childItem = {
//                        html: '<a href=""><i class="material-icons">' + subs.icon + '</i>' + subs.name + '</a>',
//                        click: function ($itemScope, $event, modelValue) {
//                          var params = {
//                            event: $event,
//                            items: $itemScope,
//                            modelValue: modelValue
//                          };
//                          EventManagerService.notifyEventListeners(subs.event, params);
//                        }
//                      };
//                      childItem.order = (subs.order && subs.order['SUB']) || 1;
//
//                      if (subs.subMenu && subs.subMenu.length > 0) {
//                        var thirdLevelItems = [];
//                        console.log(baseListSubMenu)
//                        if(subs.code == 'OFC' || subs.code == 'CSD' || subs.code == 'SOH'){
//                          prepareBasListSubmenu(baseListSubMenu)
//                          angular.forEach(baseListSubMenu, function (thirdLevelSub) {
//                            var thirdLevelItem = {
//                              html: '<a href=""><i class="material-icons">' + thirdLevelSub.icon + '</i>' + thirdLevelSub.name + '</a>',
//                              click: function ($itemScope, $event, modelValue) {
//                                var params = {
//                                  event: $event,
//                                  items: $itemScope,
//                                  modelValue: modelValue,
//                                  selectedBase: thirdLevelSub.name
//                                };
//                                EventManagerService.notifyEventListeners(getEventAccordingToEvenCode(subs.code), params);
//                              }
//                            };
//                            thirdLevelItem.order = (thirdLevelSub.order && thirdLevelSub.order['SUB']) || 1;
//                            thirdLevelItems.push(thirdLevelItem);
//                          });
//                        }
//
//                        childItem.children = thirdLevelItems;
//                      }
//
//                      childItems.push(childItem);
//
//                    }
//
//                  });
                    customItem = {
                        html: '<a href=""><i class="material-icons">' + menu.icon + '</i>' + menu.name + '</a>',
                        children: childItems,
                        enabled: function() {return true},
                        click: function ($itemScope, $event, modelValue) {
                          var params = {
                            event: $event,
                            items: $itemScope,
                            modelValue: modelValue
                          };
                        }

                      };
                      customItem.order = (menu.order && menu.order[menuType]) || 1;
                      generatedMenu.push(customItem);

                  }

              }

            }
          // end of check privilege
          });
          var sorted = null;
          try {
              sorted = _.sortBy(generatedMenu, 'order');
          } finally {
              if (!!sorted) {
                  return sorted;
              } else {
                  return generatedMenu
              }
          }
        }

      self.getContextMenu = function (type) {
          return getMenuHtml(type);
      };

    }
}());
